import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { getSubscriptionStatus } from "../utils/api";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

const ProtectedRoutes = ({ element }) => {
  const [loading, setLoading] = useState(true);
  const [hasSubscription, setHasSubscription] = useState(false);
  const isAuthenticated = localStorage.getItem("token");

  useEffect(() => {
    const checkSubscription = async () => {
      if (!isAuthenticated) {
        setLoading(false);
        return;
      }

      try {
        const res = await getSubscriptionStatus();
        if (res?.data?.data?.hasSubscription) {
          setHasSubscription(true);
        }
      } catch (error) {
        console.error("Error checking subscription:", error);
      }
      setLoading(false);
    };

    checkSubscription();
  }, [isAuthenticated]);

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-[400px]">
        <Spin indicator={<LoadingOutlined style={{ fontSize: 48, color: "black" }} spin />} />
      </div>
    );
  }

  const role = localStorage.getItem("role");

  if (!hasSubscription) {
    if (role === "manager") {
      // Manager without subscription:
      // Allow if trying to access profile (current element is Profile)
      // We can't easily check 'element.type.name' effectively in production build sometimes or if wrapped.
      // But we can check window.location.pathname or use a prop.
      // However, `element` is passed as a React element.
      // Let's rely on the fact that the Router renders this.
      // A better way is to check the current URL path.

      const currentPath = window.location.pathname;
      if (currentPath === "/profile" || currentPath === "/subscription") {
        return element;
      } else {
        return <Navigate to="/profile" />;
      }
    }
    return <Navigate to="/subscription" />;
  }

  // If user has subscription:
  if (role === "manager") {
    const currentPath = window.location.pathname;
    if (currentPath !== "/profile" && currentPath !== "/subscription") {
      return <Navigate to="/profile" />;
    }
  }

  return element;
};

export default ProtectedRoutes;
